import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Outsourcing/Hero";
import DevelopServices from "../components/Outsourcing/DevelopServices";
import Process from "../components/Outsourcing/Process";
import Customers from "../components/Outsourcing/Customers";
import OtServices from "../components/Outsourcing/OtServices";
import PageTitle from "../components/Outsourcing/PageTitle";


import '../assets/Webdevelopment.css';



const Outsourcing = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<OtServices />
	    	<Process />
	    	<Customers/>
	  </div>
	)
}

export default Outsourcing;
